import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchToilet = () => {
    const [toiletList, setToiletList] = useState([]);
    const [isToiletLoading , setIsLoading] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);

            //JSON取得
            axios.get('/assets/json/toiletData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setToiletList(data.list);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {toiletList , isToiletLoading };
}
